import React, { PropTypes } from 'react'

const MapContainer = ({ children, ...props}) => {
  return <div {...props}>{children}</div>
}

export default MapContainer
